/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserGroupList } from '../../models/user-group-list';

export interface VaultGetUserGroupList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetUserGroupList(http: HttpClient, rootUrl: string, params: VaultGetUserGroupList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGroupList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetUserGroupList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGroupList>;
    })
  );
}

vaultGetUserGroupList.PATH = '/vault/{vaultId}/user-group/list';
